import script from "./TagsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsList.vue?vue&type=script&setup=true&lang=js"

import "./TagsList.vue?vue&type=style&index=0&id=48f04ace&lang=scss"

const __exports__ = script;

export default __exports__